import moment from "moment/moment"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from "react-bootstrap/Tooltip"
import reel from "../../../assets/images/services-icon/reel.png"
import awicon from "../../../assets/images/services-icon/coin.png"
import React from "react"
import { Session } from "../session"
import { ActivityUtil } from "./activity-util"
import { ActivityCardContextMenu } from "./activity-card-context-menu"
import { ActivityCardCommonProps } from "./activity-card"
import { LessonActivityMathAQ } from "./lesson-activity.types"

interface MathOnlineActivityCardProps {
  activity: LessonActivityMathAQ
  sessionData: Session
  studentKey?: string
  index: number
}

type CardProps = MathOnlineActivityCardProps & ActivityCardCommonProps

export const MathOnlineActivityCard = (props: CardProps) => {

  const { activity, sessionData, studentKey: activityStudentKey, index } = props
  const { checkbox } = props

  let total_coins = 0
  let total_time = 0

  let total_question = 0
  let count_answer = 0

  if (activity.LessonActivitiesQuestions?.length > 0) {

    activity.LessonActivitiesQuestions.forEach(
      (activityQuestion) => {
        activityQuestion.question?.forEach(
          (question) => {
            question.question_parts?.length > 0 &&
            question.question_parts.forEach(
              (questionpat) => {
                total_question += 1
                total_coins += 2
                if (questionpat.StudentAnsAttempts?.length > 0) {
                  questionpat.StudentAnsAttempts.forEach(
                    stuAnswer => {
                      total_time += stuAnswer.submitted_on
                    }
                  )
                  count_answer += 1 // Increment count_answer by 1 for each occurrence
                }
              }
            )
          }
        )
      }
    )
  }

  return (
    <div className={`${(() => {
      if (sessionData?.session?.ses_is_completed === 1) {
        if (activity.status === 1 && activity.mastryScore) {
          const score = activity.mastryScore
          if (score > 75) return "activity-card-success"
          if (score < 75) return "activity-card-blue"
        } else if (activity.status === 1) {
          return "activity-card-blue"
        }
        return "activity-card-danger"
      }
      return ""
    })()} m-1 set1 bg-supermild`}
    >
      <div className="d-flex justify-content-between">
        <div>
          <span className="cs-txt-danger font-size-10 me-2">
            { activity?.roll_date
                ? "Rolled over from" + moment(activity.roll_date, moment.ISO_8601).format("DD/MMM/YYYY")
              : null}
          </span>
          <span
            className={`${
              activity.status === 0
                ? "cs-txt-danger"
                : activity.status === 1
                  ? "text-success"
                  : ""
            } font-size-10 me-2`}
          >
          {activity.status === 0
            ? "Incomplete"
            : activity.status === 1
              ? "Completed"
              : null}
        </span>
          <span className={`${
            activity.status === 0
              ? "cs-txt-danger"
              : activity.status === 1
                ? "text-success"
                : ""
          } font-size-10 me-2`}>
          {count_answer != null &&
          total_question != null
            ? count_answer +
            "/" +
            total_question +
            " attempted"
            : null}
        </span>
          <span className="cs-txt-danger font-size-10 me-2">
          {sessionData?.session?.ses_is_completed === 1 ? activity.mastryScore
              ? `Score: ${activity.mastryScore}` : `Score: 0`
            : null}
        </span>
          <OverlayTrigger
            placement={"top"}
            overlay={
              <Tooltip className="custom-tooltip">
                Comment:{" "}
                {activity?.tutor_comments || "No comments available"}
              </Tooltip>
            }
          >
            <span className="no-bdr" style={{ cursor: "pointer" }}>
              <i className="fas fa-info-circle"></i>
           </span>
          </OverlayTrigger>

        </div>
        {checkbox?.checkable &&
          <div>
            {(!activityStudentKey || activity.fk_student_key === activityStudentKey) &&
              <>
                <input
                  type="checkbox"
                  checked={checkbox.checked}
                  onChange={checkbox.onCheckedChanged}
                />
              </>}
          </div>
        }
      </div>
      <h6 className="text-dark border-bottom pb-1 mb-0 mt-2 font-size-12 lh-sm fw-800">
        {(index + 1) + ") "} {ActivityUtil.activityName(activity)}
      </h6>

      <div className="d-flex justify-content-between mb-2 align-items-center mt-2 flex-wrap">
        <div className="d-flex align-items-center font-size-12 text-dark fw-400">
          <span>
            {" "}
            <img className="me-10" width={24} src={reel} alt="" />
          </span>
          {activity.activity_type === 8 ? "Summative" : "Online Activities"}
        </div>

        <ActivityCardContextMenu
          {...props}
        />

      </div>

      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center font-size-12 text-dark fw-400">
        </div>

        <div className="d-flex align-items-center font-size-12 text-dark fw-400">
          {" "}
          <img className="me-10" width={24} src={awicon} alt="" />
          {activity.coins_earned ? activity.coins_earned : 0}/{total_coins}{" "}
        </div>
      </div>

      <div className="question-count mt-2">
        <ul className="list-unstyled mb-0 d-flex align-items-center mt-1">
          {activity.LessonActivitiesQuestions?.map(
              (activityQuestion, index2) => {
                let color = 0
                let attempt = 0
                let overRide = 0
                activityQuestion.question?.forEach(
                  (question) => {
                    question.question_parts?.forEach(
                      (partQuestion) => {
                        color = 0
                        attempt = 0
                        overRide = partQuestion?.markedReport
                        partQuestion.StudentAnsAttempts?.forEach(
                          (answerattquestion) => {
                            attempt += 1
                            color += answerattquestion.points_obtained
                          }
                        )
                      }
                    )
                  }
                )

                const colorInt = color
                const attemptInt = attempt
                const overRideInt = overRide
                return (
                  <li
                    key={index2}
                    className={`${
                      attemptInt >= 2 &&
                      colorInt === 1
                        ? "attempt2 text-warning bg-success-subtle"
                        : attemptInt >= 1 &&
                        colorInt === 2
                          ? "attempt1 custom-success bg-success-subtle"
                          : ((!overRideInt && attemptInt >= 2) || (overRideInt >= 1 && attemptInt >= 1)) &&
                          colorInt === 0
                            ? "attempt3 cs-txt-danger bg-danger-subtle"
                            : ""
                    }`}
                  >
                    {attemptInt >= 2 &&
                    colorInt === 1 ? (
                      <i className="fas fa-check"></i>
                    ) : attemptInt >= 1 &&
                    colorInt === 2 ? (
                      <i className="fas fa-check"></i>
                    ) : ((!overRideInt && attemptInt >= 2) || (overRideInt >= 1 && attemptInt >= 1)) &&
                    colorInt === 0 ? (
                      <i className="mdi mdi-window-close"></i>
                    ) : (
                      index2 + 1
                    )}
                  </li>
                )
              }
            )}
        </ul>
      </div>
    </div>
  )
}